<template>
    <v-content>
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="elevation-12">
                        <v-toolbar color="#7FACD6" dark flat>
                            <v-toolbar-title>修改资料</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <router-link style="margin: 20px" to="/">
                                <v-img src="../assets/close.png"></v-img>
                            </router-link>
                        </v-toolbar>
                        <v-card-text>
                            <v-form ref="form">
                                <v-text-field
                                        label="原密码"
                                        type="password"
                                        v-model="oldPassword"
                                ></v-text-field>

                                <v-text-field
                                        label="新密码"
                                        type="password"
                                        :rules="[rules.passwordrule]"
                                        v-model="password"
                                ></v-text-field>
                                <v-text-field
                                        label="确认新密码"
                                        type="password"
                                        @keyup.enter="onSubmit"
                                        :rules="[rules.confirmPassword]"
                                        v-model="confirmPassword"
                                ></v-text-field>
                                <v-text-field
                                        label="姓名"
                                        type="text"
                                        :rules="[rules.required]"
                                        v-model="name"
                                ></v-text-field>
                                <v-text-field v-if="$store.state.webUser.hospital"
                                        label="电话号码"
                                        type="text"
                                        :rules="[rules.required]"
                                        v-model="phone"
                                ></v-text-field>
                                <v-text-field
                                        label="电子邮箱"
                                        type="text"
                                        v-model="email"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#7FACD6" @click="onSubmit">修改</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-overlay :value="overlay">
            <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
            ></v-progress-circular>
        </v-overlay>

    </v-content>
</template>

<script>
    import {encrypt} from '../plugins/jsencrypt'
    export default {
        name: "Login",
        data: vm => ({
            overlay: false,
            oldPassword: '',
            password: '',
            confirmPassword: '',
            name: '',
            phone: '',
            email: '',
            rules: {
                confirmPassword: v => v === vm.password || '两次输入的密码不一致',
                required: value => !!value || '必填',
                passwordrule: value => {
                    const pattern = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>,.]).{8,16}/;
                    return pattern.test(value) || '请输入8-16位，包含字母、数字、字符的密码'
                },
                phone: value => {
                    const pattern = /^1[3456789]\d{9}$/;
                    return pattern.test(value) || '手机格式不正确'
                },
                emailRules: v => /.+@.+\..+/.test(v) || 'E-mail格式不正确',
            },
        }),
        mounted() {
            if (!this.$store.state.landing) {
                this.$snackbar.info('请登录后操作');
                this.$router.push({path: '/login'});
            } else {
                this.name = this.$store.state.webUser.name;
                this.phone = this.$store.state.webUser.phoneNumber;
                this.email = this.$store.state.webUser.email;
            }
        },
        methods: {
            onSubmit() {
                if (this.$refs.form.validate()) {
                    this.overlay = true;
                    this.oldPassword = encrypt(this.oldPassword)
                    this.password = encrypt(this.password)
                    this.$axios.get('/unicorn/updatepwd', {
                        params: {
                            oldPassword: this.oldPassword,
                            newPassword: this.password,
                            name: this.name,
                            phone: this.phone,
                            email: this.email,
                        }
                    }).then((response) => {
                        if (response.data.success) {
                            this.$snackbar.info(response.data.content);
                            this.overlay = false;
                            this.$router.push({path: '/'});
                        } else {
                            this.$snackbar.info(response.data.content);
                            this.overlay = false;
                        }
                    }).catch(() => {
                        this.$snackbar.info('连接服务器失败');
                        this.overlay = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>